import appCONST from './../../../constants/app.constants';

export const ENDPOINTS = {
    flightSearchUrl: '/flights/Search',
    flightFilterUrl: '/flights/Filter',
    eurostarSearchUrl: '/eurostar/Search',
    eurostarFilterUrl: '/eurostar/Filter',
};

export default function FlightsApiFactory(
    $http,
    sessionService
) {
    'ngInject';

    const searchUrl = ENDPOINTS.flightSearchUrl;
    const filterUrl = ENDPOINTS.flightFilterUrl;
    const searchLocationUrl = '/staticdata/SearchAirportsAlternate';
    const previousSearchesUrl = '/UserSearchParameters/UserSearch/AllFlights';
    const frequentFlightsUrl = '/authorize/GetFrequentLocationsForFlights';
    const repeatSearchUrl = '/UserSearchParameters/UserSearch/GetFlightSearchRequest';

    return {
        search,
        filter,
        searchLocation,
        getRules,
        getSearchRequestById,
        getFrequentFlights,
        getPreviousSearches,
    };

    function search(request) {
        return $http.apiPOST(searchUrl, request, {timeout: appCONST.productSearchTimeout});
    }

    function filter(parameters) {
        return $http.apiPOST(filterUrl, parameters, {timeout: appCONST.productSearchTimeout});
    }

    function searchLocation(request) {
        return $http.apiGET(searchLocationUrl, request)
            .then(({data}) => data);
    }

    function getRules(params) {
        const isReadOnlyMode = sessionService.getSessionItem('readOnlyMode');
        const anonymousLink = appCONST.serverUrl + '/api/flights/SearchRulesAnonymous';

        const requestData = {
            FlightRecommendationId: params.recommendationId,
            FareRecommendationId: params.fareId,
            FlightGroupIds: params.flightGroups,
            SearchId: params.searchId,
            Travelers: {
                Adult: params.adultCount,
                Infant: params.infantCount,
                Child: params.childCount,
            },
        };

        const requestConfig = {
            culture: params.culture,
        };

        return (isReadOnlyMode)
            ? $http.post(anonymousLink, requestData, requestConfig)
            : $http.apiPOST('/flights/SearchRules', requestData);
    }

    function getSearchRequestById(id) {
        const params = {
            searchParamId: id,
        };

        return $http.apiGET(repeatSearchUrl, {params});
    }

    function getFrequentFlights() {
        return $http.apiGET(frequentFlightsUrl, {noSpinner: true});
    }

    function getPreviousSearches(topResults, searchType) {
                const params = {
                    topResults,
                    searchType,
                };

                return $http.apiGET(previousSearchesUrl, {params});
            }
}



// WEBPACK FOOTER //
// ./src/app/modules/base/services/flightsApi.js